import { LazyVideo } from './lazy-video';

export type SampleGalleryItem = {
  video: string;
  poster?: string;
  title: string;
  description?: string;
  /** Small caption above the title (e.g. the stage name). */
  tag?: string;
};

/** Example clips: 9:16 tiles that play muted when visible, with sound via controls. */
export function SampleGallery({ items }: { items: readonly SampleGalleryItem[] }) {
  return (
    <div className="grid grid-cols-2 gap-x-4 gap-y-10 sm:gap-x-6 lg:grid-cols-3">
      {items.map((item) => (
        <figure key={item.video}>
          <LazyVideo
            src={item.video}
            poster={item.poster}
            label={item.title}
            controls
            className="aspect-[9/16] w-full rounded-2xl shadow-sm ring-1 ring-black/5"
          />
          <figcaption className="mt-4 space-y-1">
            {item.tag ? (
              <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{item.tag}</p>
            ) : null}
            <p className="text-sm font-semibold leading-6 text-foreground sm:text-base">{item.title}</p>
            {item.description ? (
              <p className="text-sm leading-6 text-muted-foreground">{item.description}</p>
            ) : null}
          </figcaption>
        </figure>
      ))}
    </div>
  );
}
